import { useTranslation } from "react-i18next";
import "../styles/stickybutton.css";

function StickyButton() {
  const { t } = useTranslation();

  return (
    <a href="#contact" className="sticky-button">
      {t("stickyButton.contact")}
    </a>
  );
}

export default StickyButton;
